import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { IResumenPoliza } from '../Entities/entities';
import * as endososPorRamo from 'src/app/shared/services/endososPorRamo.json';
import { IEndosoPorRamo } from 'src/app/modules/seguro-individual/pages/tab-administracion/transfer/interfaces/IEndososPorRamo';
@Injectable({
  providedIn: 'root',
})
export class BusinessRuleRamoService {
  descripcionCodRamo = [
    2120,
    1200,
    1300,
    7318,
    1800,
    1910,
    9660,
    9610,
    9620,
    9640,
    8510,
    1100,
    1160,
    6000,
    9750,
  ];
  descargarPolziaRamo = [
    { codigoRamo: 1100, fechaInicio: '01-03-2014' },
    { codigoRamo: 1160, fechaInicio: '01-03-2014' },
    { codigoRamo: 1800, fechaInicio: '01-03-2014' },
    { codigoRamo: 7318, fechaInicio: '01-09-2015' },
    { codigoRamo: 9640, fechaInicio: '01-01-2016' },
    { codigoRamo: 9660, fechaInicio: '01-01-2016' },
    { codigoRamo: 9661, fechaInicio: '02-05-2024' },
    { codigoRamo: 9662, fechaInicio: '03-06-2024' },
    { codigoRamo: 9740, fechaInicio: '01-01-2016' },
    { codigoRamo: 9750, fechaInicio: '01-01-2016' },
    { codigoRamo: 9840, fechaInicio: '01-08-2018' },
    { codigoRamo: 9850, fechaInicio: '01-08-2014' },
    { codigoRamo: 6900, fechaInicio: '01-01-2019' },
    { codigoRamo: 7300, fechaInicio: '01-03-2019' },
    { codigoRamo: 9620, fechaInicio: '01-11-2011' },
    { codigoRamo: 9720, fechaInicio: '01-07-2010' },
    { codigoRamo: 9730, fechaInicio: '01-08-2010' },
    { codigoRamo: 9630, fechaInicio: '01-03-2011' },
    { codigoRamo: 9760, fechaInicio: '01-01-2016' },
  ];
  codigoRamoAportePago = [
    9640,
    8510,
    8502,
    8500,
    9730,
    9750,
    9700,
    9740,
    9620,
    9660,
    9661,
    9662,
    9610,
    9692,
    8430,
    9710,
    9720,
    9760,
  ];
  codigoRamoPago = [
    1100,
    1160,
    1150,
    6000,
    6906,
    7300,
    1800,
    7318,
    1910,
    2100,
    7316,
    2120,
    9720,
    9710,
    1200,
    1300,
    6907,
    6900,
    2400,
    2130,
    7000,
  ];
  codigoRamoAporte = [8720, 9820];
  codigoRamoCUInoAPV = [9750, 9700, 9730, 9740, 9720, 9710, 9820];
  codigoRamoNoCUIPF = [1200, 1300];
  codigoRamoCUIAPVRegimen = [9620, 9660, 9661, 9662, 9610];
  codigoRamoPeriodicas = [
    9640,
    8510,
    8502,
    8500,
    9730,
    9750,
    9700,
    9740,
    9620,
    9660,
    9661,
    9662,
    9610,
    1100,
    1160,
    6000,
    6906,
    7300,
    1800,
    7318,
    1910,
    2100,
    7316,
    2120,
    9720,
    9710,
    1200,
    1300,
    9760,
    2130,
    7000,
  ];
  codigoRamoEsporadicas = [
    9640,
    8510,
    8502,
    8500,
    8720,
    9730,
    9750,
    9700,
    9740,
    9620,
    9660,
    9661,
    9662,
    9610,
    9820,
    8430,
    9692,
    9710,
    9720,
    9760,
  ];

  codigoRamoAPVAportesEsporadicos = [
    8510,
    9610,
    9620,
    9630,
    9640,
    9650,
    9660,
    9661,
    9662,
    9692,
  ];
  codigoRamoCUIAportesEsporadicos = [
    8000,
    8430,
    8500,
    8502,
    8720,
    9700,
    9710,
    9720,
    9730,
    9740,
    9750,
    9760,
    9800,
    9810,
    9820,
    9840,
    9900,
  ];

  constructor() {}

  isApvOCUIProductoAportesEsporadicos(codigoRamo: any): boolean {
    return (
      this.codigoRamoAPVAportesEsporadicos.includes(codigoRamo) ||
      this.codigoRamoCUIAportesEsporadicos.includes(codigoRamo)
    );
  }

  getLabelPago(nombreProducto: any): string {
    if (nombreProducto.indexOf('LIFE MAX') >= 0) {
      return null;
    } else {
      return 'PAGO DE PRIMAS';
    }
  }

  getLabelAporte(codigoRamo: any, nombreProducto: any): string {
    const codigoR = parseInt(codigoRamo, 10);
    if (
      this.isApvOCUIProductoAportesEsporadicos(codigoR) &&
      nombreProducto.indexOf('LIFE MAX') == -1
    ) {
      return 'APORTES';
    } else {
      return null;
    }
  }

  getLabelAportesPagosRealizadosByCodigo(codigoRamo: any): string {
    const codigoR = parseInt(codigoRamo, 10);
    if (this.codigoRamoAportePago.some(codigo => codigo === codigoR)) {
      return 'HISTORIAL DE PAGOS Y APORTES';
    } else if (this.codigoRamoPago.some(codigo => codigo === codigoR)) {
      return 'HISTORIAL DE PAGOS';
    } else if (this.codigoRamoAporte.some(codigo => codigo === codigoR)) {
      return 'HISTORIAL DE APORTES';
    } else {
      return null;
    }
  }

  getLabelResumenPeriodico(codigoRamo: any): string {
    const codigo = parseInt(codigoRamo, 10);
    if (this.codigoRamoAporte.some(c => c === codigo)) {
      return 'Inicial';
    } else {
      return 'Periódica';
    }
  }

  showMessageCuiNoApv(codigoRamo): boolean {
    const codigo = parseInt(codigoRamo, 10);
    return this.codigoRamoCUInoAPV.some(c => c === codigo);
  }

  showMessageCuiApvRegimen(codigoRamo): boolean {
    const codigo = parseInt(codigoRamo, 10);
    return this.codigoRamoCUIAPVRegimen.some(c => c === codigo);
  }

  showMessageDecember(date = moment()) {
    return date.format('DD-M') === '28-12';
  }

  showEsporadica(codigoRamo) {
    const codigo = parseInt(codigoRamo, 10);
    return this.codigoRamoEsporadicas.some(c => c === codigo);
  }

  showPeriodica(codigoRamo) {
    const codigo = parseInt(codigoRamo, 10);
    return codigo !== 9820 && codigo !== 9840;
  }

  showProductDescription(codigoRamo) {
    const codigo = parseInt(codigoRamo, 10);
    return this.descripcionCodRamo.some(d => d === codigo);
  }

  showRescate(tipoProducto: string) {
    return tipoProducto !== 'Tradicional' ? true : false;
  }

  showFormByCodProducto(codigoRamo, form) {
    const retorno = { muestraForm: false, lineaNegocio: '' };
    const grupoEndosos = endososPorRamo.default as IEndosoPorRamo[];
    for (const x of grupoEndosos) {
      if (x.tipo === form) {
        const grupo = x.codigoLinea.find(y => y.codRamo === codigoRamo);
        if (grupo) {
          retorno.muestraForm = true;
          retorno.lineaNegocio = grupo.lineaNegocio;
        }
        break;
      }
    }

    return retorno;
  }

  showPagarMisProductos(codigoRamos: any[]): boolean {
    const codigos = codigoRamos.map(c => parseInt(c, 10));

    if (this.codigoRamoAportePago.some(c => codigos.some(cod => cod === c))) {
      return true;
    } else if (this.codigoRamoPago.some(c => codigos.some(cod => cod === c))) {
      return true;
    } else if (
      this.codigoRamoAporte.some(c => codigos.some(cod => cod === c))
    ) {
      return true;
    } else {
      return false;
    }
  }

  showNoCuiPF(resumen: IResumenPoliza): boolean {
    if (
      resumen.ViaPago.toUpperCase() === 'POR EMPLEADOR/DESCUENTO POR PLANILLA'
    ) {
      return false;
    }
    const codigo = parseInt(resumen.CodigoRamo, 10);
    return this.codigoRamoNoCUIPF.some(c => c === codigo);
  }

  showDownloadIndividual(resumen: IResumenPoliza): boolean {
    if (!resumen) {
      return false;
    }

    const element = this.descargarPolziaRamo.find(
      d => d.codigoRamo === parseInt(resumen.CodigoRamo, 10)
    );

    if (!element) {
      return false;
    }

    const isAfter = moment(resumen.InicioVigencia).isAfter(
      moment(element.fechaInicio, 'DD-MM-YYYY')
    );

    return isAfter;
  }
}
